import { render, staticRenderFns } from "./Biodiversity.vue?vue&type=template&id=3a22da9b"
import script from "./Biodiversity.vue?vue&type=script&lang=js"
export * from "./Biodiversity.vue?vue&type=script&lang=js"
import style0 from "./Biodiversity.vue?vue&type=style&index=0&id=3a22da9b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports